import Decimal from 'decimal.js';

export const toFixed = (value?: Decimal | string | number) =>
  new Decimal(value ?? 0).toFixed(2);

export const toIntegral = (value?: Decimal | string | number) =>
  Number(new Decimal(value ?? 0).times(100).toFixed(0));
